module.exports = __webpack_public_path__ + "img/kerry1d_charge_logo.0e8173ab.png";